import { ConsumableId } from "../../../game/Consumable";

/**
 * The readouts a reward flight's chips fly to. Each one marks itself with
 * `data-reward-target`, and `RewardFlightLayer` measures it at launch time —
 * the top bar reflows, so the vector can't be hard-coded.
 *
 * A missing target is not an error: a chip may name a fallback (the
 * supply tally's rows are only in the DOM while it's open, so a nail
 * aimed at the nails row lands on the word "Supplies" instead), and the
 * layer simply drops any chip whose targets aren't mounted rather than
 * flinging it at the corner.
 */
export type RewardTarget =
  "money" | "reputation" | "xp" | "supplies" | `supply:${ConsumableId}`;

export const REWARD_TARGET_ATTRIBUTE = "data-reward-target";

/** The tally row for one kind of supply. */
export function supplyTarget(id: ConsumableId): RewardTarget {
  return `supply:${id}`;
}
